var exports = {
  "container": "x43cbe9c2--a71807--container",
  "page": "x43cbe9c2--a71807--page",
  "little": "x43cbe9c2--a71807--little",
  "title": "x43cbe9c2--a71807--title",
  "main-banner": "x43cbe9c2--a71807--main-banner",
  "house": "x43cbe9c2--a71807--house",
  "second-banner": "x43cbe9c2--a71807--second-banner",
  "text-block": "x43cbe9c2--a71807--text-block",
  "btn": "x43cbe9c2--a71807--btn",
  "image": "x43cbe9c2--a71807--image",
  "cian-pin": "x43cbe9c2--a71807--cian-pin",
  "cian-calendar": "x43cbe9c2--a71807--cian-calendar",
  "keys": "x43cbe9c2--a71807--keys",
  "chair": "x43cbe9c2--a71807--chair",
  "smb-pre-footer": "x43cbe9c2--a71807--smb-pre-footer",
  "tablet": "x43cbe9c2--a71807--tablet",
  "phone": "x43cbe9c2--a71807--phone",
};

module.exports = exports;
